import { getItemTypeForDmItem } from './getItemTypeForDynaMakerItem'
import * as DynamakerContract from '../integration/DynamakerContract'

export const getEditorialDataFromSelectedItem = (selectedItem: any, renderItems: any): any => {
  const _internalId = getInternalId(selectedItem)

  const itemTypeKey = getItemTypeForDmItem(selectedItem.item)
  if (!itemTypeKey) return undefined
  const renderItem = renderItems[itemTypeKey].find((renderItem: any) => renderItem._internalId === _internalId)

  return renderItem?._editorial
}

const getInternalId = (selectedItem: DynamakerContract.Item) => {
  if (selectedItem?.props?.configData)
    return `${selectedItem.erpItemNumber}--${selectedItem.props.configData.namedConfigCode}`

  switch (selectedItem.item) {
    case 'door':
      return `${selectedItem.item}--${selectedItem.props.kind}`
    case 'window':
      return `${selectedItem.item}--${selectedItem.props.kind}--${selectedItem.props.moduleHeight}`
    case 'garage-door':
    case 'double-door':
    case 'sliding-door':
    case 'facade-section':
      return `${selectedItem.item}--${selectedItem.props.kind}--${selectedItem.props.openingWidth}--${selectedItem.props.openingHeight}`
    default:
      throw new Error(`unhandled item type: ${JSON.stringify(selectedItem)}`)
  }
}
